// @flow @format
import {handleActions} from 'lib/redux-actions';

export const TOGGLE_HISTORY = 'TOGGLE_HISTORY';
export const OPEN_HISTORY = 'OPEN_HISTORY';
export const CLOSE_HISTORY = 'CLOSE_HISTORY';

type Action = {type: string};

export function toggleHistory(): Action {
	return {type: TOGGLE_HISTORY};
}

export function openHistory(): Action {
	return {type: OPEN_HISTORY};
}

export function closeHistory(): Action {
	return {type: CLOSE_HISTORY};
}

export type State = {
	+visible: boolean,
	+current: boolean,
	+archived: boolean,
};

export const initialState: State = {
	visible: false,
	current: false,
	archived: false,
};

const reducer = handleActions(
	{
		[TOGGLE_HISTORY]: (state: State): State => ({
			...state,
			visible: !state.visible,
		}),
		[OPEN_HISTORY]: (state: State): State => ({...state, visible: true}),
		[CLOSE_HISTORY]: (state: State): State => ({...state, visible: false}),
	},
	initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/history.js